import { Injectable, InjectionToken, Inject, Optional } from '@angular/core';
import { ObjectUtils } from "@ark-libs/ngx-utils";
import { CoreConfig } from '../config/core-config';

const SERVICE_ROOT_URL = '/';
const SERVICE_BASE_URL = {
    UAA: '${SERVICE_ROOT_URL}uaa/',
    BASE:'${SERVICE_ROOT_URL}base/',
    MNS: '${SERVICE_ROOT_URL}mns/',
    PAY: '${SERVICE_ROOT_URL}pay/',
    IMG: '${SERVICE_ROOT_URL}image/'
};
const API_URL = {
    oauthToken:     '${SERVICE_BASE_URL.UAA}oauth/token',
    account:        '${SERVICE_BASE_URL.UAA}api/account',
    getResourceTree:'${SERVICE_BASE_URL.UAA}api/resource-tree',
    offices:        '${SERVICE_BASE_URL.UAA}api/offices',

    displayPic:     '${SERVICE_BASE_URL.BASE}api/_public/picture/display/',
    uploadFile:     '${SERVICE_BASE_URL.IMG}api/image/upload',

    dictMap:        '${SERVICE_BASE_URL.BASE}api/dicts',
    webappSettings: '${SERVICE_BASE_URL.BASE}api/_public/settings?scope=web',

    myCommunityGroups:      '${SERVICE_BASE_URL.UAA}api/_offices/_my/community_groups',
    myCommunityRegions:     '${SERVICE_BASE_URL.UAA}api/_offices/_my/branch_regions',
    myCommunities:          '${SERVICE_BASE_URL.UAA}api/_offices/_my/communities',
    // myCommunityAndCityTree: '${SERVICE_BASE_URL.UAA}api/_offices/_my/communities_with_city',
    
    myAppTree:   '${SERVICE_BASE_URL.UAA}api/_my/_resources/app-tree',
    myNavTree:   '${SERVICE_BASE_URL.UAA}api/_my/_resources/nav-tree',
};
const SETTINGS = {
    LOGO_HEADER_ICON:   'app.web.common.logo_header_icon',
    LOGO_HEADER_FULL:   'app.web.common.logo_header',
    LOGO_LOGIN:         'app.web.common.logo_login',
    COPYRIGHT:          'app.web.common.copyright_info',
    PHOTO_BASE_URL:     'photo.base_url',
    WEIXIN_AUTH_HTML:   'weixin.auth.offical.html',
    DOMAIN_CONFIG_LOGIN_PAGE:   'domain-config.login_page',
    DOMAIN_CONFIG_MAIN_PAGE:    'domain-config.main_page',
    BASE_CLIENT_APP_PACKAGE_DOWNLOAD_URL: 'gm-base.client-app.package.download_url'
};

export const NGX_WEBAPP_FX_CORE_CONFIG = new InjectionToken('NGX_WEBAPP_FX_CORE_CONFIG');

@Injectable({ providedIn:'root' })
export class CoreConfigService implements CoreConfig {
	private _config: CoreConfig;

    constructor(@Optional() @Inject(NGX_WEBAPP_FX_CORE_CONFIG) config: CoreConfig){
        this.setConfig(config);
    }

    public setConfig(config : CoreConfig) {
        this._config = {
            serviceRootUrl  :SERVICE_ROOT_URL,
            serviceBaseUrls :SERVICE_BASE_URL,
            apiUrls         :API_URL,
            settingKeys     :SETTINGS,
            applicationSets :{},
            applicationKeys :{},

            appletsSelectMode:"COLLAPSE",
            appletsHideNotPermission: false,
            appletsShowNotPermissionOfficeLevel: ['COMMUNITY','COMMUNITY_GROUP','BRANCH_REGION'],
            canActiveAppletSelector: true,
            hiddenAppletTitle: false,
            canActiveOfficeSelector: true,
            hiddenOfficeTitle:false,
            hiddenNoticeIcon:false,
            cookiePathMode: 'ROOT',
            requestAuthMode: 'HEADER',
            isDevMode: (location.hostname=='127.0.0.1'||location.hostname=='localhost'||location.hostname.startsWith("192.168.")),
            loginPage:{
                appTitle:'云管理平台'
            },
            mainPage:{},
        };
        ObjectUtils.patchDataWhileNotNull(config, this._config);
        // console.log(this._config);

        // 解析apiUrls
        let rootUrl, baseUrl;
        Object.keys(SERVICE_BASE_URL).forEach(serviceKey=>{

            rootUrl = this._config.serviceRootUrl;
            if(rootUrl.length>0 && rootUrl.lastIndexOf('/')!=rootUrl.length-1) rootUrl += "/";
            this._config.serviceRootUrl = rootUrl;

            baseUrl = SERVICE_BASE_URL[serviceKey].replace("${SERVICE_ROOT_URL}", rootUrl);
            if(baseUrl.lastIndexOf('/')!=baseUrl.length-1) baseUrl += "/";
            SERVICE_BASE_URL[serviceKey] = baseUrl;

            Object.keys(API_URL).forEach(apiKey=>{
                API_URL[apiKey] = API_URL[apiKey].replace("${SERVICE_BASE_URL."+serviceKey+"}", baseUrl);
            });
        });
    }

    get serviceRootUrl() {
        return this._config.serviceRootUrl;
    }
    get serviceBaseUrls() {
        return this._config.serviceBaseUrls;
    }
    get apiUrls() {
        return this._config.apiUrls;
    }
    get applicationSets() {
        return this._config.applicationSets;
    }
    get applicationKeys() {
        return this._config.applicationKeys;
    }
    get settingKeys() {
        return this._config.settingKeys;
    }
    get appletsSelectMode():string{
        return this._config.appletsSelectMode;
    }
    get appletsHideNotPermission():boolean{
        return this._config.appletsHideNotPermission;
    }
    get appletsShowNotPermissionOfficeLevel():string[]{
        return this._config.appletsShowNotPermissionOfficeLevel||[];
    }
    get appletsApplicationSet() : string {
        return this._config.appletsApplicationSet||this._config["appletsApplicationSetName"] // ||'web_apps';
    }
    get appletsExtraApplication() : string {
        return this._config.appletsExtraApplication||this._config["appletsExtraApplicationName"];
    }
    get entryApplication() : string {
        return this._config.entryApplication||this._config["entryApplicationName"];
    }
    get entryOfficeId() : number {
        return this._config.entryOfficeId||this._config["defaultEntryOfficeId"];
    }
    get entryOfficeCode() : string {
        return this._config.entryOfficeCode;
    }

    get canActiveAppletSelector() : boolean {
        return this._config.canActiveAppletSelector;
    }
    get hiddenAppletTitle() : boolean {
        return this._config.hiddenAppletTitle;
    }
    get canActiveOfficeSelector() : boolean {
        return this._config.canActiveOfficeSelector&&this.entryOfficeCode==null&&this.entryOfficeCode==null;
    }
    get hiddenOfficeTitle() : boolean {
        return this._config.hiddenOfficeTitle;
    }
    get hiddenNoticeIcon() : boolean {
        return this._config.hiddenNoticeIcon;
    }
    get userCenterApplication() : string {
        return this._config.userCenterApplication;
    }

    get navShowType() : string {
        return this._config.navShowType;
    }

    get rightNavMenu() : any {
        return this._config.rightNavMenu;
    }
    get requestAuthMode(): 'HEADER'|'COOKIE' {
        return this._config.requestAuthMode;
    }
    get cookiePathMode() : 'ROOT'|'PATH' {
        return this._config.cookiePathMode;
    }
    get appDefaultDashboard() : string {
        return this._config.appDefaultDashboard;
    }
    get homePage() : string {
        return this._config.homePage;
    }
    get loginPage() : any {
        return this._config.loginPage;
    }
    get mainPage() : any {
        return this._config.mainPage;
    }

    get isDevMode() : boolean {
        return this._config.isDevMode;
    }

    mergeConfig(config:any){
        if(config){
            try{
                if(typeof config ==='string') config = JSON.parse(config);
                ObjectUtils.patchDataWhileNotNull(config, this._config);
            }catch{}
            // console.log(this._config);
        }
    }


    get(key: string){
        return this.getFieldValue(this._config, key);
    }

    private getFieldValue(obj: any, key: string): any {
    	if(key == null || key.length == 0) return;
    	let splitKeys = key.split(".");
    	let result = obj;
    	for(let i = 0; i < splitKeys.length; i ++){
    		if(result == null) break;
    		if(result instanceof Object){
	    		result = result[splitKeys[i]];
	    	}else{
	    		result = null;
	    		break;
	    	}
    	}
    	//if(result == null){
    	//	console.warn("get core config value is null: ", key);
    	//}
    	return result;
    }
}
